import { useMutation } from "@tanstack/react-query";
import { lodGrpsApi, lodListApi } from "components/api/comm";
import { lgnPwdChkApi, logoutApi } from "components/api/member";
import { apifield, timeout } from "components/utils/comm";
import { ILodList } from "interface/home";
import { ILodGrp } from "interface/index";
import { Dispatch, SetStateAction, useEffect, useRef } from "react";
import useAlertStore from "store/alert";
import useAuthStore from "store/auth";
import useLodGrpListStore from "store/lodGrpList";
import useLodListStore from "store/lodList";

// 숙소그룹 리스트
export const useLodGrpList = () => {
  const isLogin = useAuthStore((state) => state.isLogin);
  const lodGrpListRef = useRef<ILodGrp[]>([]);
  const setLodGrpList = useLodGrpListStore((state) => state.setLodGrpList);
  const mutation = useMutation({
    mutationFn: lodGrpsApi,
    onSuccess: (res) => {
      if (res) {
        const {
          status: { code, message },
          data,
        } = res;
        if (code === 0) {
          // 성공
          lodGrpListRef.current = data.lodGrpList;
          setLodGrpList(data.lodGrpList);
        }
        if (code === -1) {
          apifield(message);
        }
      }
    },
  });
  useEffect(() => {
    if (isLogin) {
      mutation.mutate();
    }
  }, [isLogin]);

  return {
    lodGrpList: lodGrpListRef.current,
  };
};

// 숙소 리스트
export const useLodList = () => {
  const isLogin = useAuthStore((state) => state.isLogin);
  const lodListRef = useRef<ILodList[]>([]);
  const setLodList = useLodListStore((state) => state.setLodList);

  const mutation = useMutation({
    mutationFn: lodListApi,
    onSuccess: (res) => {
      if (res) {
        const {
          status: { code, message },
          data,
        } = res;
        if (code === 0) {
          // 성공
          lodListRef.current = data.lodList;
          setLodList(data.lodList);
        }
        if (code === -1) {
          apifield(message);
        }
      }
    },
  });
  useEffect(() => {
    if (isLogin) {
      mutation.mutate();
    }
  }, [isLogin]);

  return {
    lodList: lodListRef.current,
  };
};

// 로그아웃
export const useLogoutApi = () => {
  return useMutation({
    mutationKey: ["member-logout"],
    mutationFn: logoutApi,
    onSuccess: (res) => {
      if (res) {
        const {
          status: { code, message },
        } = res;
        if (code === 0) {
          sessionStorage.removeItem("isLogin-session");
          timeout();
        }
        if (code === -1) {
          apifield(message);
        }
      }
    },
  });
};

export const useLogout = () => {
  const onSetAlert = useAlertStore((state) => state.onSetAlert);
  const { mutate } = useLogoutApi();
  const onLogout = () => {
    onSetAlert({
      isOpen: true,
      inner: "로그아웃 하시겠습니까?",
      cnclBtn: true,
      chkBnt: true,
      onSetConfirm: () => {
        // 로그아웃 진행
        mutate();
      },
    });
  };

  return {
    onLogout,
  };
};
// 회원 확인
type ICheckMemProps = {
  setOpenModal: Dispatch<SetStateAction<boolean>>;
};
export const useCheckMemApi = ({ setOpenModal }: ICheckMemProps) => {
  return useMutation({
    mutationKey: ["member-manager-check"],
    mutationFn: lgnPwdChkApi,
    onSuccess: (res) => {
      if (res) {
        const {
          status: { code, message },
        } = res;

        if (code === 0) {
          // 회원 확인 완료 , 매니저모달창 오픈
          setOpenModal(true);
        }
        if (code === -1) {
          apifield(message);
        }
      }
    },
  });
};
